export default __webpack_public_path__ + "static/media/Missionary's Shield.e410ab1a.jpg";